import React from "react";
import { Link } from "react-router-dom";

function RegisterInvest() {
  return (
    <div className="">
      <div className="flex justify-center items-center mx-32 m-auto md:grid-col-2 md:m-auto  lg:grid-cols-2">
        <div className="w-full shadow-md mt-10 mb-10 ml-10">
          <div className="relative py-8 px-5  md:px-10 bg-white shadow-sm rounded h-full ">
            <h1 className="text-gray-800 ml-36 text-4xl font-bold tracking-normal leading-tight mb-10">
              <strong className="text-[#dbe361] ">Buy</strong> Fresh Tomatoes
            </h1>
            <form>
              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                Full Name
              </label>
              <input
                id="name"
                className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-yellow font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                placeholder="Name"
              />
              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                Price
              </label>
              <div className="relative mb-5 mt-2">
                <input
                  id="email2"
                  className="text-gray-600 focus:outline-none focus:border focus:border-yellow font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  placeholder="$100"
                  type="number"
                  value="$100"
                />
              </div>
              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                Quantity
              </label>
              <select className="text-gray-600 focus:outline-none focus:border focus:border-yellow font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border">
                <option>1 kiish - $50</option>
                <option>2 kiish - $100</option>
                <option>3 kiish - $150</option>
              </select>

              <Link to="/pay">
                {" "}
                <div className="flex items-center justify-start w-full">
                  <button className="focus:outline-none transition duration-150 ease-in-out hover:bg-[#eef771] bg-[#dbe361] rounded text-white px-8 py-2 text-sm w-3/5 m-auto mt-20">
                    <strong>Payment</strong>
                  </button>
                </div>{" "}
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterInvest;
